module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon1.a4041237.svg";